import genericsFn from '../../styles/generics/styles'

export default genericsFn



// WEBPACK FOOTER //
// ./containers/app/styles.js